module.exports = __webpack_public_path__ + "img/product-shot_01_loading.f9ea0de0.jpg";